/**
 * Analytics Service Public API
 *
 * External code should ONLY import from this file.
 * Provider implementations are not exposed.
 */

import { isOnPrem } from '../../config'
import useFirebaseAnalytics from './hooks/useFirebaseAnalytics'
import useNoOpAnalytics from './hooks/useNoOpAnalytics'

// Compile-time hook selection based on environment
// At build time, webpack replaces process.env.REACT_APP_ENV,
// allowing dead code elimination to remove unused implementations
let useAnalyticsImpl
if (isOnPrem) {
  useAnalyticsImpl = useNoOpAnalytics
} else {
  useAnalyticsImpl = useFirebaseAnalytics
}
export const useAnalytics = useAnalyticsImpl

// Types
export type { AnalyticsHook } from './types'
// For backward compatibility
export type { AnalyticsHook as AnalyticsProvider } from './types'
